import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ErrorInterceptor implements HttpInterceptor {
  private readonly toast = inject(MessageService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (!req.url.includes('/health')) {
          this.toast.add({
            severity: err.status >= 500 ? 'error' : 'warn',
            summary: `Error ${err.status}`,
            detail: err.error?.message ?? err.message,
            life: 5000,
          });
        }
        return throwError(() => err);
      }),
    );
  }
}
